'use client'

import { ProductCarousel } from '@/components/common'
import { ProductCardSkeleton } from '@/components/common/product-card/product-item-skeleton'
import { useProductSuggestion } from '@/hooks/react-query/products/use-product'
import { ETrackingEvent } from '@/lib/gtm/type'
import { useScrollTracking } from '@/lib/gtm/use-tracking-section'
import { cn } from '@/lib/utils'
import { useTranslations } from 'next-intl'
import { useRef } from 'react'

export const ProductInfoSuggestion = ({
  productId,
  genderType,
}: {
  productId: string
  genderType: string
}) => {
  const ref = useRef<HTMLDivElement>(null)
  const t = useTranslations('product_detail.title')
  const { data, isLoading } = useProductSuggestion(productId)

  useScrollTracking({
    elementRef: ref,
    event: ETrackingEvent.ViewSuggestionProduct,
    product_id: productId,
    products: data?.map((item) => item.id),
    active: !!data?.length,
  })

  if (isLoading) {
    return (
      <div className='m-4 grid auto-cols-[160px] grid-flow-col gap-4 overflow-x-auto md:auto-cols-fr md:grid-cols-3 lg:grid-cols-4'>
        {[...Array(4)].map((_, i) => (
          <ProductCardSkeleton key={i} />
        ))}
      </div>
    )
  }

  if (!data) {
    return null
  }

  return (
    <section
      className={cn(
        'bg-light px-5 py-8 lg:p-15',
        genderType === 'FEMALE' && 'lg:pt-0'
      )}
      aria-label={t('product_suggestion')}
      ref={ref}
    >
      <h2 className='mb-3 font-criteria text-lg font-medium uppercase leading-6.5 text-neutral-900 lg:mb-4 lg:text-[28px] lg:leading-10'>
        {t('product_suggestion')}
      </h2>
      <ProductCarousel
        products={data}
        gaTrackingValue='product-detail__product-suggestion'
        gaTrackingLabel='product-detail__product-suggestion'
      />
    </section>
  )
}
